import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-information-item',
    templateUrl: './information-item.component.html',
    imports: [CommonModule,],
    styleUrls: ['./information-item.component.css']
})
export class InformationItemComponent {
  @Input('myColor1') myColor1:any;
  @Input('myColor2') myColor2:any;

  @Input('title')title=""
  @Input('content')content=""
  @Input('date')date=""




 
}
